import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {  RouterModule, Routes } from '@angular/router';
import { SharedModule } from '../../../modules/shared/shared.module';


import { FileUploadComponent } from './file-upload/file-upload.component';
import { confirmationGuard } from '../../../confirmation/confirmation.guard';
import { FileuploadService } from './file-upload/service/fileupload.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { AudioRecordsComponent } from './audio-records/audio-records.component';
import { ProgressMonitorComponent } from './progress-monitor/progress-monitor.component';
import { ProgressService } from './progress-monitor/service/progress.service';
 
import { PermissionService } from '../../../permission.service';
import { ConfigurationComponent } from './configuration/configuration.component';
import { UserManagementComponent } from './user-management/user-management.component';
import { UserDetailsComponent } from './user-details/user-details.component';
import { NewUserComponent } from './new-user/new-user.component';
import { UserService } from './user-management/service/user.service';

const routes:Routes=[
  {
    path:'audioRecords',component:AudioRecordsComponent
  },
        {path:'fileUpload', component:FileUploadComponent, canDeactivate:[confirmationGuard]},
   {path:'progress', component:ProgressMonitorComponent, },
    {
            path:'configuration',
            component:ConfigurationComponent,
            canActivate:[PermissionService],
             data:{ roles:['102'] }
           }, {path:'userManagement', 
                     component:UserManagementComponent, 
                     canActivate:[PermissionService],
                     data:{ roles:['102'] },
                     children:[{path:':id', component:UserDetailsComponent},{path:'newUser', component:NewUserComponent}]
                   },{
    redirectTo:'audioRecords',
    pathMatch:'full',
    path:''
  }
];


@NgModule({
  declarations: [AudioRecordsComponent,FileUploadComponent,ProgressMonitorComponent,ConfigurationComponent,UserManagementComponent,UserDetailsComponent,NewUserComponent],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule.forChild(routes),
    
  ],
  providers:[FileuploadService,ProgressService,PermissionService,UserService],
  schemas:[CUSTOM_ELEMENTS_SCHEMA]
})
export class PostCallModule { }
